<template>
  <kst-section collapsed
    :collapsible="sectionCollapsible"
    :title="Info.Section.DebtPay.Title"
    :help-collapsed="sectionHelp"
  >
    <kst-input field="DueDate" :data="userData" :catalog="Catalog"
      :customValidations="dueDateValidations"
    />
    <kst-input field="PaymentTypeName" :data="userData" :catalog="Catalog"
      :options="paymentOptions"
    />
    <template v-if="paymentValueVisible">
      <kst-input field="PaymentValue" :data="userData" :catalog="Catalog">
        <template #left>
          <div class="control">
            <kst-button fullPaymentMode @click="handlePaymentValue_fullPayment"/>
          </div>
        </template>
      </kst-input>
    </template>
  </kst-section>
</template>

<script>
import Catalog from "../RcvCatalog.js";
import Info from "../RcvInfo.js";
import Model from "../RcvModel.js";

export default {
  props: {
    paymentOptions: Object,
    userData: Object
  },
  data: () => ({
    Catalog: Catalog,
    Info: Info
  }),
  computed: {
    dueDateValidations() {
      return Model.New.validationDueDate();
    },
    paymentValueVisible() {
      return this.userData.PaymentTypeName !== this.$kst.Search.OptionNone;
    },
    sectionCollapsible() {
      return this.userData.PaymentTypeName === this.$kst.Search.OptionNone;
    },
    sectionHelp() {
      return Model.getDebtPaySectionHelp(this.userData);
    }
  },
  methods: {
    handlePaymentValue_fullPayment() {
      Model.New.setDetailsByFullPayment(this.userData);
    }
  }
}
</script>